export default "__VITE_ASSET__BJ8QG3rU__"